<template>
  <div>
    <v-row>
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">{{ title }}</v-toolbar-title>
          <v-spacer/>
          <v-btn
            @click="$router.push({ name: 'app.dashboard' });"
            color="teal darken-1" dark
            depressed rounded>
            <v-icon>mdi-chevron-left</v-icon>
            Voltar
          </v-btn>
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header"/>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-toolbar dense flat color="tertiary">
            <v-toolbar-title class="custon-toolbar-title">Destalhes</v-toolbar-title>
          </v-toolbar>

          <v-card-text flat class="py-4">
             <v-simple-table class="table-bordered" dense>
              <template v-slot:default>
                <tbody>
                  <tr>
                    <td >
                      <small><b>Nome</b></small>
                      <br>
                       {{ authUser.pessoa.nome }}
                    </td>
                    <td>
                    <small><b>CPF</b></small>
                    <br>
                    {{ authUser.pessoa.cpf_cnpj }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <small><b>Perfil</b></small>
                      <br>
                      {{ perfis }}
                    </td>
                    <td>
                    <small><b>Email</b></small>
                    <br>
                    {{ authUser.email }}
                    </td>
                  </tr>
                  <tr>
                   <td colspan="2">
                      <small><b>Instituições</b></small>
                      <br>
                      {{ instituicoes }}
                    </td>
                  </tr>
                  <tr>
                   <td colspan="2">
                      <small><b>Orgãos</b></small>
                      <br>
                      {{ orgaos }}
                    </td>
                  </tr>
                  <tr>
                   <td colspan="2">
                      <small><b>Departamentos</b></small>
                      <br>
                      {{ departamentos }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-btn class="mt-4"
              depressed
              color="green" dark
              type="submit"
              @click="toggleFormPassord"
              >
              <v-icon small left>mdi-lock</v-icon>
              Alterar Senha
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-model-form/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import VModelForm from './ModalForm.vue';

export default {
  name: 'ShowMe',
  components: {
    VModelForm,
  },
  metaInfo: {
    title: 'Dados do Usuário',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    title: 'Dados do Usuário',
  }),
  methods: {
    ...mapActions('auth', [
      'toggleFormPassord',
    ]),
  },
  computed: {
    ...mapState('auth', ['authUser', 'modalFormAlterPassword']),
    instituicoes() {
      if (this.authUser.id) {
        return this.authUser.instituicoes.map((instituicao) => instituicao.nome).join(', ');
      }
      return null;
    },
    orgaos() {
      if (this.authUser.id) {
        return this.authUser.orgaos.map((orgao) => orgao.nome).join(', ');
      }
      return null;
    },
    departamentos() {
      if (this.authUser.id) {
        return this.authUser.departamentos.map((departamento) => departamento.nome).join(', ');
      }
      return null;
    },
    perfis() {
      if (this.authUser.id) {
        return this.authUser.perfis.map((perfil) => perfil.nome).join(', ');
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
  .table-bordered {
    border: thin solid rgba(0, 0, 0, 0.12);

    tr td:nth-child(2) {
      border-left: thin solid rgba(0, 0, 0, 0.12);
    }
  }
</style>
